export default "__VITE_ASSET__CO2CLAT0__"